/**
 * Extracts URL parameters for login flows from URLSearchParams
 */
export const extractUrlParameters = (urlParams: URLSearchParams) => {
  // Helper function to get parameter or undefined if empty or null
  const getParam = (key: string) => {
    const value = urlParams.get(key);
    return value === "" || value === null ? undefined : value;
  };

  return {
    email: getParam("email"),
    screen_hint: getParam("screen_hint"),
    token: getParam("token"),
    prompt: getParam("prompt"),
    _gl: getParam("_gl"),
    utm_source: getParam("utm_source"),
    utm_medium: getParam("utm_medium"),
    utm_campaign: getParam("utm_campaign"),
    utm_content: getParam("utm_content"),
    utm_referer: getParam("utm_referer"),
    gclid: getParam("gclid"),
    fbclid: getParam("fbclid"),
    msclkid: getParam("msclkid"),
    li_fat_id: getParam("li_fat_id"),
    ext_gaClientId: getParam("ext-gaClientId"),
    ext_gaSessionId: getParam("ext-gaSessionId"),
    ext_anonymousId: getParam("ext-anonymousId"),
  };
};
